export default __webpack_public_path__ + "static/media/client31.d40b6ca2.png";